const AUTO_ADD_CONFIG = {
  trigger_product_ids: [
    '9341046817096',
    '9759441092936',
    '9759540871496'
],
  subscription_product_id: '51929397625160',
  subscription_selling_plan_id: '690474975560'
};

let is_adding_subscription_global = false;

async function handle_cart_addition_main(cart_response) {
  if (is_adding_subscription_global) {
    return;
  }

  const should_add = await check_if_trigger_product_added(cart_response);
  
  if (should_add) {
    is_adding_subscription_global = true;
    console.log('Trigger product detected, adding subscription product...');
    
    try {
      await add_subscription_product_to_cart();
      console.log('Auto-add subscription completed');
    } catch (error) {
      console.error('Auto-add subscription failed:', error);
    } finally {
      setTimeout(() => {
        is_adding_subscription_global = false;
      }, 1000);
    }
  }
}

function validate_settings() {
  const { MinimogSettings } = window;
  if (!MinimogSettings || !MinimogSettings.routes || !MinimogSettings.routes.cart_add_url) {
    throw new Error('Cart settings not available');
  }
  return MinimogSettings;
}

function get_cart_drawer() {
  return document.querySelector('m-cart-drawer');
}

function prepare_cart_data() {
  return {
    items: [
      {
        id: AUTO_ADD_CONFIG.subscription_product_id,
        quantity: 1,
        selling_plan: AUTO_ADD_CONFIG.subscription_selling_plan_id
      }
    ]
  };
}

function add_sections_to_cart_data(cart_data, cart_drawer, minimog_settings) {
  if (cart_drawer && minimog_settings.enable_cart_drawer) {
    cart_data.sections = cart_drawer.getSectionsToRender().map((section) => section.id);
    cart_data.sections_url = window.location.pathname;
  }
  return cart_data;
}

function make_cart_add_request(cart_data, minimog_settings) {
  const config = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(cart_data)
  };

  return fetch(minimog_settings.routes.cart_add_url, config)
    .then(response => response.json());
}

function handle_cart_add_error(response) {
  if (response.status) {
    const error_message = response.description || response.message || 'Failed to add product to cart';
    console.error('Failed to add subscription product to cart:', error_message);
    throw new Error(error_message);
  }
  return response;
}

function update_cart_drawer(response, cart_drawer, minimog_settings) {
  if (cart_drawer && minimog_settings.enable_cart_drawer && response.sections) {
    cart_drawer.renderContents(response);
  } else if (cart_drawer && minimog_settings.enable_cart_drawer) {
    cart_drawer.onCartDrawerUpdate();
  }
}

function update_cart_count(item_count) {
  if (item_count === undefined) return;

  const cart_counts = document.querySelectorAll('.m-cart-count-bubble');
  cart_counts.forEach((cart_count) => {
    if (item_count > 0) {
      cart_count.textContent = item_count;
      cart_count.classList.remove('m:hidden');
    } else {
      cart_count.classList.add('m:hidden');
    }
  });
}

function emit_cart_events(response) {
  if (window.MinimogEvents) {
    window.MinimogEvents.emit(window.MinimogTheme?.pubSubEvents?.cartUpdate || 'cart:updated', response);
  }
  
  document.dispatchEvent(new CustomEvent('cart:updated', { detail: response }));
}

function add_subscription_product_to_cart() {
  const minimog_settings = validate_settings();
  const cart_drawer = get_cart_drawer();
  let cart_data = prepare_cart_data();
  cart_data = add_sections_to_cart_data(cart_data, cart_drawer, minimog_settings);

  return make_cart_add_request(cart_data, minimog_settings)
    .then(response => {
      handle_cart_add_error(response);
      update_cart_drawer(response, cart_drawer, minimog_settings);
      update_cart_count(response.item_count);
      emit_cart_events(response);
      console.log('Subscription product added to cart successfully');
      return response;
    })
    .catch(error => {
      console.error('Error adding subscription product to cart:', error);
      throw error;
    });
}

function fetch_cart_items() {
  return fetch(`${window.Shopify?.routes?.root || ''}cart.json`)
    .then(response => response.json())
    .then(cart => cart?.items || null)
    .catch(() => null);
}

function get_cart_items(cart_response) {
  if (cart_response && cart_response.items) {
    return Promise.resolve(cart_response.items);
  }
  return fetch_cart_items();
}

function item_matches_id(item, product_id) {
  return item.product_id === parseInt(product_id) ||
         String(item.product_id) === product_id ||
         item.id === parseInt(product_id) ||
         String(item.id) === product_id ||
         item.variant_id === parseInt(product_id) ||
         String(item.variant_id) === product_id;
}

function check_if_any_trigger_product_in_cart(cart_items) {
  return AUTO_ADD_CONFIG.trigger_product_ids.some(trigger_id => 
    cart_items.some(item => item_matches_id(item, trigger_id))
  );
}

function check_if_subscription_in_cart(cart_items) {
  return cart_items.some(item => 
    item_matches_id(item, AUTO_ADD_CONFIG.subscription_product_id)
  );
}

async function check_if_trigger_product_added(cart_response) {
  const cart_items = await get_cart_items(cart_response);
  
  if (!cart_items) {
    return false;
  }
  
  const trigger_found = check_if_any_trigger_product_in_cart(cart_items);
  const subscription_exists = check_if_subscription_in_cart(cart_items);
  
  return trigger_found && !subscription_exists;
}

function debounce_cart_addition(cart_response, debounce_timer_ref) {
  if (debounce_timer_ref.current) {
    clearTimeout(debounce_timer_ref.current);
  }
  
  debounce_timer_ref.current = setTimeout(async () => {
    await handle_cart_addition_main(cart_response);
  }, 100);
}

function setup_product_ajax_listener(debounce_timer_ref) {
  document.addEventListener('product-ajax:added', function(event) {
    const cart_response = event.detail?.product;
    debounce_cart_addition(cart_response, debounce_timer_ref);
  });
}

function setup_minimog_events_listener(debounce_timer_ref) {
  if (!window.MinimogEvents || !window.MinimogTheme) {
    return;
  }

  window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.cartUpdate, function(cart_response) {
    if (is_adding_subscription_global) {
      return;
    }
    debounce_cart_addition(cart_response, debounce_timer_ref);
  });
}

function init_auto_add_subscription() {
  const debounce_timer_ref = { current: null };
  
  setup_product_ajax_listener(debounce_timer_ref);
  setup_minimog_events_listener(debounce_timer_ref);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init_auto_add_subscription);
} else {
  init_auto_add_subscription();
}
